// @flow
import React from 'react'
import Lamps from '../components/lamps'
import * as actionTypes from '../constants/action_types'
import * as ids from '../constants/ids'

export type ServiceType = {
    description: string,
    icon: string,
    id: string,
    name: string,
    render: Function,
}

export type ServicesType = {
    items: ServiceType[],
    result?: {},
    running: boolean,
}

export type ActionType = {
    actionId: string,
    result?: {},
}

const initialState = {
    items: [{
        description: 'Land use data extraction (LAMPS)',
        icon: 'fa fa-tag',
        id: ids.DATA_LAMPS,
        name: 'LAMPS',
        render: props => (<Lamps {...props} />),
    }],
    result: undefined,
    running: false,
}

export const reducer = (state: ServicesType = initialState, action: ActionType) => {
    let ret = state
    if (action.type === actionTypes.LAMPS_START) {
        ret = {
            ...state,
            running: true,
        }
    } else if (action.type === actionTypes.LAMPS_END) {
        ret = {
            ...state,
            result: action.result,
            running: false,
        }
    }
    return ret
}

export default reducer
